
import React from 'react';
import { Button } from "@/components/ui/button";
import { Download, Upload } from 'lucide-react';

interface ALMDashboardHeaderProps {
  title: string;
}

const ALMDashboardHeader: React.FC<ALMDashboardHeaderProps> = ({ title }) => {
  return (
    <div className="flex items-center justify-between mb-4">
      <h2 className="text-2xl font-bold">{title}</h2>
      <div className="flex gap-2">
        <Button variant="outline" size="sm">
          <Download className="h-4 w-4 mr-2" />
          Export
        </Button>
        <Button variant="outline" size="sm">
          <Upload className="h-4 w-4 mr-2" />
          Import
        </Button>
      </div>
    </div>
  );
};

export default ALMDashboardHeader;
